import { render, staticRenderFns } from "./history-appointment.vue?vue&type=template&id=0d85b74e"
import script from "./history-appointment.vue?vue&type=script&lang=js"
export * from "./history-appointment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports